import Vue from 'vue';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';

// START:AUTOLOAD
const requireComponent = require.context('@/components/_globals', false, /.+\.(vue|js)$/);
requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName);
  const componentName = upperFirst(
    camelCase(
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, ''),
    ),
  );

  Vue.component(componentName, componentConfig.default || componentConfig);
});
// END:AUTOLOAD

// START:IGNORE_ELEMENTS
Vue.config.ignoredElements = [/^ion-/];
// END:IGNORE_ELEMENTS
